export default {
  CRAPPY: '1',
  STORMY: '2',
  CLOUDY: '3',
  SUNNY: '4'
}
